import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGame, IGameState } from '../../interface/game';

const initialState: IGameState = {
  game: undefined,
  isGameGetPending: undefined,

  error: '',
  isGameLeadSubmitPending: false,
  fonts: [],
};

export const gameSlicer = createSlice({
  name: 'game',
  initialState,
  reducers: {
    setGame: (state, { payload }: PayloadAction<IGame>) => {
      state.game = payload;
    },
    setFonts: (state, { payload }: PayloadAction<Array<string>>) => {
      state.fonts = payload;
    },
    setIsGameGetPending: (state, { payload }: PayloadAction<boolean>) => {
      state.isGameGetPending = payload;
    },

    setGameError: (state, { payload }: PayloadAction<string>) => {
      state.error = payload;
    },

    setIsGameLeadSubmitPending: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      state.isGameLeadSubmitPending = payload;
    },
  },
});

export const {
  setGame,
  setFonts,
  setIsGameGetPending,
  setGameError,
  setIsGameLeadSubmitPending,
} = gameSlicer.actions;

export default gameSlicer.reducer;
